import React, { useEffect } from 'react'
import AziendaFrom from '../../rightSidebar/AziendaFrom'
import { Box } from '@mui/material'
import TerreniForm from '../Terreni/TerreniForm'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleTerreni } from '../../../features/terreni/terreniThunk'
export const CantineTerreniSlider = ({ cantine, setCantine }) => {
    const cantineSingleData = useSelector((state)=> state.cantine.singleCantines)
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Terreno</h2>
            </Box>
            <TerreniForm cantine={cantine} setCantine={setCantine}  cantineSingleData={cantineSingleData}/>
        </Box>
    )
}